export enum Environment {
  Local,
  Dev,
  Int,
  Qa,
  Prod,
  Con2,
  Con3
}

export const getEnvironment = (): Environment => {
  switch (window.location.hostname.toLowerCase()) {
    case 'solar360.int.igssolarpower.com':
      return Environment.Int
    case 'solar360.qa.igssolarpower.com':
      return Environment.Qa
    case 'solar360.dev.igssolarpower.com':
      return Environment.Dev
    case 'solar360.igssolarpower.com':
    case 'solar360.prod.igssolarpower.com':
      return Environment.Prod
    case 'solar360.con2.igssolarpower.com':
          return Environment.Con2
    case 'solar360.con3.igssolarpower.com':
        return Environment.Con3
    default:
      return Environment.Local
  }
}
